module.exports = __webpack_public_path__ + "dc8cc292.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/ClinicaMedica/19524.jpg
// module id = 1315
// module chunks = 0 1